// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__yxaiV","left":"InfoRow_left__21dnX"};